function sliderMain() {
    var swiper = new Swiper('.main .mySwiper', {
        slidesPerView: 1,
        spaceBetween: 15,
        speed: 500,
        navigation: {
            nextEl: ".main .swiper-button-next",
            prevEl: ".main .swiper-button-prev",
        },
        pagination: {
            el: ".main .swiper-pagination",
            clickable: true
        },
    })
}

function sliderFeedback() {
    var swiper = new Swiper('.feedback .mySwiper', {
        slidesPerView: 1.4,
        spaceBetween: 32,
        speed: 500,
        navigation: {
            nextEl: ".feedback .swiper-button-next",
            prevEl: ".feedback .swiper-button-prev",
        },
        pagination: {
            el: ".feedback .swiper-pagination",
            clickable: true
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 15,
            },
            577: {
                slidesPerView: 1.31,
                spaceBetween: 32,
            },
        }
    })
}

function sliderProductMain() {
    var swiper = new Swiper(".product-main__slider .mySwiper", {
        slidesPerView: 5,
        spaceBetween: 12,
        freeMode: true,
        watchSlidesProgress: true,
        direction: "vertical",
        breakpoints: {
            320: {
                spaceBetween: 7,
                direction: "horizontal",
            },
            577: {
                spaceBetween: 12,
                direction: "vertical",
            }
        }
    });
    var swiper2 = new Swiper(".product-main__slider .mySwiper2", {
        spaceBetween: 12,
        slidesPerView: 1,
        thumbs: {
            swiper: swiper,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
}

function sliderFeedback2() {
    var swiper = new Swiper('.feedback2 .mySwiper', {
        slidesPerView: 2,
        spaceBetween: 20,
        speed: 500,
        navigation: {
            nextEl: ".feedback2 .swiper-button-next",
            prevEl: ".feedback2 .swiper-button-prev",
        },
        pagination: {
            el: ".feedback2 .swiper-pagination",
            clickable: true
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            744: {
                slidesPerView: 2,
            },
        }
    })
}

$(document).ready(function () {
    sliderMain();
    sliderFeedback();
    sliderProductMain();
    sliderFeedback2();

    // Menu
    $('.burger').click(function () {
        $('.header-menu').addClass('header-menu--active')
        $('body').addClass('fixed-body')
    })

    $('.header-menu__close').click(function () {
        $('.header-menu').removeClass('header-menu--active')
        $('body').removeClass('fixed-body')
    })

    $('.header-menu__bg').click(function () {
        $(this).parents('.header-menu').removeClass('header-menu--active')
        $('body').removeClass('fixed-body')
    })

    // Search
    $('.header__search-btn').click(function () {
        $(this).parents('.header__inner').addClass('search-active')
    })

    $('.header__search-close').click(function () {
        const $header = $(this).closest('.header__inner');

        $header.removeClass('search-active');
        $header.find('.search__input').val('').trigger('input');
    });

    $('.search__input').on('input', function () {
        $(this)
            .siblings('.search__clear')
            .toggleClass('active', $(this).val().length > 0);
    });

    $('.search__clear').on('click', function () {
        $(this)
            .removeClass('active')
            .siblings('.search__input')
            .val('')
            .focus();
    });

    // Favorite
    $('.favorite').click(function () {
        $(this).toggleClass('favorite--active')
    })

    // Select
    $('.custom-select').niceSelect();

    // Filter
    $('.filter__btn').click(function () {
        $('.filter-menu').addClass('filter-menu--active')
        $('body').addClass('fixed-body')
    })

    $('.filter__close, .filter__close2').click(function () {
        $('.filter-menu').removeClass('filter-menu--active')
        $('body').removeClass('fixed-body')
    })

    // Fancybox
    Fancybox.bind("[data-fancybox]", {});

    // Calc
    function calc() {
        $('.calc').each(function () {
            let $calc = $(this);
            let $input = $calc.find('input');
            let $minus = $calc.find('.calc-minus');

            function checkValue() {
                let value = +$input.val();

                if (value === 0) {
                    $minus.addClass('null');
                } else {
                    $minus.removeClass('null');
                }
            }

            checkValue();

            $minus.click(function () {
                let a = +$input.val();

                if (a > 0) {
                    $input.val(a - 1);
                }

                checkValue();
            });

            $calc.find('.calc-plus').click(function () {
                let a = +$input.val();

                $input.val(a + 1);

                checkValue();
            });
        });
    }

    calc();

    // Tabs
    $(".tab").click(function () {
        let path = $(this).attr("data-tab-path")
        $(this).siblings(".tab").removeClass("tab--active")
        $(this).addClass("tab--active")

        $(this).parents(".tabs-inner").find(".tab__content").removeClass("tab__content--active")
        $(this).parents(".tabs-inner").find(`.tab__content[data-content-path="${path}"]`).addClass("tab__content--active")
    })

    // Basket
    $('.basket-card__close').click(function () {
        $(this).parents('.basket-card').remove()
    })

    // Promocode
    function promocode() {
        $('.promocode__btn').click(function (e) {
            e.preventDefault();

            const $btn = $(this);
            const $promocode = $btn.closest('.promocode');
            const $basket = $btn.closest('.basket__group2');
            const $input = $promocode.find('.promocode__input input');

            if ($promocode.hasClass('promocode--active')) {
                return;
            }

            const code = $input
                .val()
                .trim()
                .toUpperCase();

            let percent = 0;

            if (code === 'HALE10') {
                percent = 10;
            }

            if (code === 'LOVE20') {
                percent = 20;
            }

            if (!percent) {
                $promocode.find('.promocode__text3').show();
                return;
            }

            const price = parseInt(
                $basket
                    .find('.basket__items .basket__item:first-child .basket__item-text2')
                    .text()
                    .replace(/[^\d]/g, '')
            );

            const sale = Math.round(price * percent / 100);
            const newPrice = price - sale;

            $promocode.addClass('promocode--active');
            $basket.find('.sale').addClass('sale--active');
            $basket.find('.basket__price-old').addClass('price-old--active');

            $promocode.find('.promocode__text3').hide();

            $promocode.find('.promocode__text2, .promocode__text2-1').hide();

            if (code === 'HALE10') {
                $promocode.find('.promocode__text2').show();
            }

            if (code === 'LOVE20') {
                $promocode.find('.promocode__text2-1').show();
            }

            $basket
                .find('.sale .basket__item-text')
                .text(`Скидка (${code})`);

            $basket
                .find('.sale .basket__item-text2')
                .text('-' + sale.toLocaleString('ru-RU') + ' ₽');

            $basket
                .find('.basket__price-new')
                .text(newPrice.toLocaleString('ru-RU') + ' ₽');

            $input.prop('disabled', true);
            $btn.prop('disabled', true);
        });
    }

    promocode();

})